import { render, staticRenderFns } from "./SubscriptionTypeTable.vue?vue&type=template&id=9a351fc2&"
import script from "./SubscriptionTypeTable.vue?vue&type=script&lang=js&"
export * from "./SubscriptionTypeTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports